import ApiKeyservice from '@/services/apiKeys.js';
import { isAllowedTo } from '../../utils/capabilites';

const initialState = () => {
	return {
		apiKeys: [],
		dropdownApiKeys: [],
		apiKey: {},
		selectedApiKey: {},
		searchParams: {
			name: '',
			orderBy: 'Name',
			pageSize: 10,
			currentPage: 1
		},
		totalCount: 0,
		totalPages: 0,
		errorMessage: ''
	};
};

const state = initialState();

export default {
	debug: false,
	namespaced: true,
	state,
	mutations: {
		SET_DROPDOWN_APIKEYS(state, ApiKeys) {
			state.dropdownApiKeys = ApiKeys;
		},
		SET_APIKEYS(state, ApiKeys) {
			state.apiKeys = ApiKeys;
		},
		SET_APIKEY(state, ApiKey) {
			state.apiKey = ApiKey;
		},
		SET_SELECTED_APIKEY(state, ApiKey) {
			state.selectedApiKey = ApiKey;
		},
		SET_PAGESIZE(state, pageSize) {
			state.searchParams.pageSize = pageSize;
		},
		SET_CURRENTPAGE(state, currentPage) {
			state.searchParams.currentPage = currentPage;
		},
		SET_TOTALPAGES(state, totalPages) {
			state.totalPages = totalPages;
		},
		SET_TOTALCOUNT(state, totalCount) {
			state.totalCount = totalCount;
		},
		SET_ERRORMESSAGE(state, errorMessage) {
			state.errorMessage = errorMessage;
		},
		RESET(state) {
			Object.assign(state, initialState());
		}
	},

	actions: {
		async getApiKey({ commit }, ApiKeyId) {
			return await ApiKeyservice.getApiKey(ApiKeyId)
				.then(data => {
					commit('SET_APIKEY', data);
				})
				.catch(err => {
					console.log('Error getting ApiKey: ', err);
				});
		},
		async getApiKeys({ state, commit, dispatch, rootGetters }) {
			dispatch('appStore/setLoading', 1, { root: true });
			state.searchParams.companyId = rootGetters['user/getActiveCompany'].id;
			state.searchParams.customerId = rootGetters['user/getActiveCustomer']?.id;

			return await ApiKeyservice.getApiKeys(state.searchParams)
				.then(data => {
					const paginationValues = data._pagination;

					if (state.searchParams.currentPage <= paginationValues.totalPages || paginationValues.totalPages == 0) {
						commit('SET_APIKEYS', data);
						commit('SET_CURRENTPAGE', paginationValues.currentPage);
						commit('SET_TOTALCOUNT', paginationValues.totalCount);
						commit('SET_TOTALPAGES', paginationValues.totalPages);
					} else {
						commit('SET_CURRENTPAGE', paginationValues.totalPages);
						dispatch('getApiKeys');
					}

					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting ApiKeys: ', err);
					commit('SET_ERRORMESSAGE', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},

		async getDropdownApiKeys({ commit, rootGetters }, name) {
			var searchParams = {
				name: name,
				orderBy: 'name',
				currentPage: 1,
				pageSize: 10
			};

			if (!rootGetters['user/getUser'].companyId || !isAllowedTo('apikeys_access_view'))
				return;

			searchParams.companyId = rootGetters['user/getActiveCompany'].id;

			return await ApiKeyservice.getApiKeys(searchParams)
				.then(data => {
					commit('SET_DROPDOWN_APIKEYS', data);
				})
				.catch(err => {
					console.log('Error getting ApiKeys: ', err);
				});
		},

		async getApiKeysByCustomParams({ dispatch }, params) {
			dispatch('appStore/setLoading', 1, { root: true });

			return await ApiKeyservice.getApiKeys(params)
				.then(res => {
					dispatch('appStore/setLoading', -1, { root: true });

					return res;
				})
				.catch(err => {
					console.log(err);

					dispatch('appStore/setLoading', -1, { root: true });

					return err;
				});
		},

		async createApiKey({ dispatch, commit }, ApiKey) {
			return await ApiKeyservice.createApiKey(ApiKey)
				.then(() => {
					console.log('Skapade nyckel');
					dispatch('getApiKeys');
					dispatch('getDropdownApiKeys');
				})
				.catch(err => {
					commit('SET_ERRORMESSAGE', err);
					console.log('Error creating ApiKey: ', err);
				});
		},

		async deleteApiKey({ dispatch, commit }, ApiKeyId) {
			return await ApiKeyservice.deleteApiKey(ApiKeyId)
				.then(() => {
					dispatch('getApiKeys');
					dispatch('getDropdownApiKeys');
				})
				.catch(err => {
					commit('SET_ERRORMESSAGE', err);
					console.log('Error deleting ApiKey: ', err);
				});
		},

		setApiKey({ commit }, ApiKey) {
			commit('SET_APIKEY', ApiKey);
		},

		setSelectedApiKey({ commit }, ApiKey) {
			commit('SET_SELECTED_APIKEY', ApiKey);
		},

		setCurrentPage({ commit }, currentPage) {
			commit('SET_CURRENTPAGE', currentPage);
		},

		setPageSize({ commit }, pageSize) {
			commit('SET_PAGESIZE', pageSize);
		},

		setTotalPages({ commit }, totalPages) {
			commit('SET_TOTALPAGES', totalPages);
		},

		setTotalCount({ commit }, totalCount) {
			commit('SET_TOTALCOUNT', totalCount);
		}
	},

	getters: {
		totalPages: state => {
			return state.totalPages;
		},
		totalCount: state => {
			return state.totalCount;
		},
		currentPage: state => {
			return state.searchParams.currentPage;
		},
		pageSize: state => {
			return state.searchParams.pageSize;
		},
		apiKey: state => {
			return state.apiKey;
		},
		apiKeys: state => {
			return state.apiKeys;
		},
		dropdownApiKeys: state => {
			return state.dropdownApiKeys;
		},
		pagination: state => {
			return {
				currentPage: state.searchParams.currentPage,
				pageSize: state.searchParams.pageSize,
				totalPages: state.totalPages,
				totalCount: state.totalCount
			};
		},
		selectedApiKey: state => {
			return state.selectedApiKey;
		}
	}
};
